<template lang="pug">
#requests_and_holidays.vue-time-off-requests-and-holidays-list.row.pl-15.pr-15.mb-10(
  v-if="!timeOffRequestsIsEmpty || !holidaysIsEmpty"
)
  .col-xs-12
    .d-flex.justify-content-between.flex-column.flex-sm-row.mb-10
      h4
        span.date Time off and holidays
    .time-off-activites.mb-20
      .d-flex.justify-content-start.align-items-center.flex-column.flex-md-row.time-off-activity(
        v-for="(request, index) in timeOffRequests"
        :key="`${request.starts_at}-${request.stops_at}-${index}`"
      )
        .pl-md-10.pr-30.pb-md-0.type.pb-10.pl-0.d-flex.align-items-center
          strong
            | {{ request.policy_name }}
          span.min-fit-content
            | : {{ $filters.formatDuration(request.amount_used) }}
          PaymentRecordLink.min-fit-content(
            :team-payment-detail="request.team_payment_detail",
            :timesheet-team-payment-id="timesheetTeamPaymentId"
          )
        .pb-md-0.pb-10.pr-20
          span(v-if="!request.all_day || !isSameDate(request.starts_at, request.stops_at)")
            strong.mr-5 From
            span(v-if="request.all_day")
              | {{ $filters.formatDate(formatAbsoluteDate(request.starts_at)) }}
            span(v-else)
              | {{ formatInZone(request.starts_at) }}
            strong.ml-5.mr-5 to
            span(v-if="request.all_day")
              | {{ $filters.formatDate(formatAbsoluteDate(request.stops_at)) }}
            span(v-else)
              | {{ formatInZone(request.stops_at) }}
          span(v-else)
            strong.mr-5 Date
            | {{ $filters.formatDate(formatAbsoluteDate(request.starts_at)) }}

      .d-flex.justify-content-start.align-items-center.flex-column.flex-md-row.time-off-activity.holiday(
        v-for="(holiday, index) in holidays"
        :key="`${holiday.date}-${index}`"
      )
        .pl-md-10.pr-30.pb-md-0.type.pb-10.pl-0.d-flex.align-items-center
          strong
            | {{ holiday.name }}
          | : {{ $filters.formatDuration(holiday.amount_used) }}
          PaymentRecordLink.min-fit-content(
            :team-payment-detail="holiday.team_payment_detail",
            :timesheet-team-payment-id="timesheetTeamPaymentId"
          )
        .pb-md-0.pb-10.pr-20
          strong.mr-5 Date
          | {{ $filters.formatDate(holiday.date) }}
        .mr-md-0.ml-auto.mr-auto
</template>

<script>
import { isEmpty } from 'lodash-es';
import { parseInternalDatetime, formatDatetime } from '~/utils/time_utils';
import PaymentRecordLink from './PaymentRecordLink.vue';

export default {
  name: 'TimeOffRequestsAndHolidaysList',
  components: {
    PaymentRecordLink,
  },
  props: {
    timeOffRequests: {
      type: Array,
      default: () => [],
    },
    holidays: {
      type: Array,
      default: () => [],
    },
    zone: {
      type: String,
      required: true,
    },
    timesheetTeamPaymentId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    timeOffRequestsIsEmpty() {
      return isEmpty(this.timeOffRequests);
    },
    holidaysIsEmpty() {
      return isEmpty(this.holidays);
    },
  },
  methods: {
    isSameDate(start, stop) {
      return this.formatAbsoluteDate(start) === this.formatAbsoluteDate(stop);
    },
    formatAbsoluteDate(dateString) {
      return parseInternalDatetime(dateString).format('YYYY-MM-DD');
    },
    formatInZone(datetime) {
      datetime = parseInternalDatetime(datetime).tz(this.zone);

      return formatDatetime(datetime);
    },
  },
};
</script>
